import { render, staticRenderFns } from "./DeviceQuota.vue?vue&type=template&id=25805609&scoped=true&"
import script from "./DeviceQuota.vue?vue&type=script&lang=js&"
export * from "./DeviceQuota.vue?vue&type=script&lang=js&"
import style0 from "./DeviceQuota.vue?vue&type=style&index=0&id=25805609&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25805609",
  null
  
)

export default component.exports